export default __webpack_public_path__ + "static/NDE-Offshore-16e5dd8df4d9638bc42720cb5cffbd2f.webp";